import { parseAnalitycsFilters } from './parseAnalitycsFilters';

export const parseAnalitycsFullFilters = ({ pagination, sort, filters }) => ({
  pagination,
  sort,
  filters: filters ? parseAnalitycsFilters(filters) : undefined,
});
